import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import alertActions from 'ducks/alert/actions';
import { NoodleToastFixed } from '.';
import type { NoodleToastProps } from './NoodleToast.types';

class AlertContainer extends React.Component<NoodleToastProps> {
  render() {
    const { alert, onCloseAlert } = this.props;
    return alert ? <NoodleToastFixed alert={alert} onCloseAlert={onCloseAlert} /> : null;
  }
}

const mapStateToProps = (state) => ({
  alert: get(state, 'alert', {}),
});

const mapDispatchToProps = {
  onCloseAlert: () => alertActions.removeAlert(),
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertContainer);
